import gql from 'graphql-tag';

export default gql`
  query microsoftOfficeEditorURL(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    microsoftOfficeEditorURL(
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
